import { motion } from "framer-motion";

export const PageBanner = ({ image, icon: Icon, title, subtitle, text }) => {
  return (
    <section className="relative pt-[70px] min-h-[60vh] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className="absolute inset-0 bg-[#0f1410]/80" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0f1410] to-transparent" />
      <div className="grain" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 py-16 text-center"
      >
        {Icon && (
          <div className="w-16 h-16 mx-auto rounded-full border-2 border-[#d4af37] flex items-center justify-center mb-6 gold-glow bg-[#0f1410]/60">
            <Icon className="w-8 h-8 text-[#d4af37]" />
          </div>
        )}
        <h1 className="font-heading font-bold uppercase text-4xl md:text-6xl tracking-tight text-white">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-3 font-heading uppercase tracking-[0.15em] text-[#d4af37] text-lg md:text-xl">
            {subtitle}
          </p>
        )}
        {text && (
          <p className="mt-6 text-sm md:text-base text-[#e0e0e0] max-w-2xl mx-auto leading-relaxed">
            {text}
          </p>
        )}
      </motion.div>
    </section>
  );
};
